import React, { useEffect, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@/core/redux/store';
import { defaultAvatar } from '@/utils/imagepath';
import { postData } from '@/services/api.service';
import { setUserDetails } from '@/core/redux/commonSlice';
import toaster from '@/components/toaster/toaster';

const schema = yup.object().shape({
  name: yup.string().required('Name is required'),
  email: yup.string().email('Invalid email').required('Email is required'),
  phone: yup.string().required('Phone is required'),
  image: yup
    .mixed()
    .nullable()
    .test('fileSize', 'File is too large', (value) => {
      if (!value || value.length === 0) return true;
      return value[0]?.size <= 5 * 1024 * 1024; // 5MB
    }),
});

type FormValues = {
  name: string;
  email: string;
  phone: string;
  image: FileList | null;
};

const NeedHelp = () => {
  const [loading, setLoading] = useState(false);
  const user = useSelector((state: RootState) => state.common.userDetails);
  console.log(user);

  const dispatch = useDispatch();

  useEffect(() => {
    console.log(user);
  }, []);

  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormValues>({
    resolver: yupResolver(schema),
    defaultValues: {
      name: '',
      email: '',
      phone: '',
      image: null,
    },
  });

  // Reset form when user data is available
  useEffect(() => {
    if (user) {
      reset({
        name: user.name || '',
        email: user.email || '',
        phone: user.phone || '',
        image: null,
      });
    }
  }, [user, reset]);

  const onSubmit = async (data: FormValues) => {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('email', data.email);
    formData.append('phone', data.phone);
    if (data.image && data.image.length > 0) {
      formData.append('image', data.image[0]);
    }

    try {
      setLoading(true);
      const response = await postData('update-profile', formData);
      if (response?.status == 200 || response?.status == 201) {
        toaster.success(response?.data?.message);
        const updatedImage = response.data?.image || user.image;
        dispatch(
          setUserDetails({
            ...user,
            name: data.name,
            email: data.email,
            phone: data.phone,
            image: updatedImage,
          })
        );
      }
    } catch (error) {
      console.error('Submission failed:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="row">
        <div className="col-md-12">
          <div className="user-dashboard-tab__content tab-content">
            <div
              className="tab-pane fade show active"
              id="account_details"
              role="tabpanel"
            >
              <form
                className="mar-top-40 row"
                onSubmit={handleSubmit(onSubmit)}
                encType="multipart/form-data"
              >
                <div className="chat-window">
                  <div className="chat-cont-right">
                      <div className="chat-cont-right-chat">
                          <div className="chat-header p-0">
                              <div className="media">
                                  <div className="media-img-wrap">
                                      <div className="avatar">
                                          <img src={defaultAvatar} alt="User Image" className="avatar-img rounded-circle" />
                                      </div>
                                      <div className="user-name" id="username">Admin</div>
                                  </div>
                                  {/* <div className="media-body">
                                  </div> */}
                              </div>
                          </div>
                          <div className="chat-body">
                              <div className="chat-scroll">
                                  <div className="chatlist-unstyled" id="chatlist"><ul className="list-unstyled"><li className="media sent"><div className="media-body"><div className="msg-box"><div><p>Hi</p><ul className="chat-msg-info"><li><div className="chat-time"><span>2 hours ago</span></div></li></ul></div></div></div></li></ul></div>                                    
                                  <div className="file-preview d-none"></div>
                              </div>
                          </div>
                          <div className="chat-footer">
                              <div className="input-group">
                                  <div className="input-group-prepend">
                                      <div className="btn-filebtn">
                                          <input type="file" name="chat_attach_file" id="chat_attach_file" />
                                          <label><i className="ti ti-paperclip"></i></label>
                                      </div>
                                  </div>
                                  <input type="text" className="input-msg-send form-control" id="textMessage" placeholder="Type something" />
                                  <div className="input-group-append">
                                      <button type="button" className="btn msg-send-btn"><i className="fa fa-paper-plane"></i></button>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
                {/* <div className="col-12">
                  <button
                    type="submit"
                    className="button style1 mt-3"
                    disabled={loading}
                  >
                    {loading ? 'Sending...' : 'Send'}
                  </button>
                </div> */}
              </form>
            </div>
          </div>
        </div>
      </div>
  );
};

export default NeedHelp;
